import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class EpicsCount extends Field {
  static availableForModel(modelClass, recordLayout) {
    return super.availableForModel(modelClass, recordLayout);
  }

  static attributesForModel() {
    return ['epicsCount'];
  }

  get title() {
    return `${terminology('Epics')} count`;
  }

  exampleContents(): FieldContentsData {
    return { text: `3 ${terminology('epics')}` };
  }

  contentsForRecord(record): FieldContentsData {
    return {
      text: `${record.epicsCount} ${terminology('epic', {
        isPlural: record.epicsCount > 1,
      })}`,
    };
  }
}
